"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var PriceCellRenderer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PriceCellRenderer, _Component);

  function PriceCellRenderer() {
    (0, _classCallCheck2.default)(this, PriceCellRenderer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PriceCellRenderer).apply(this, arguments));
  }

  (0, _createClass2.default)(PriceCellRenderer, [{
    key: "render",
    value: function render() {
      var value = this.props.value;
      if (value === null || value === undefined) return _react.default.createElement("span", null, "-");

      if (typeof value === 'object') {
        var displayPrice = '-';

        if (value && value.price) {
          displayPrice = value.currency ? value.price.toLocaleString(undefined, {
            style: 'currency',
            currency: value.currency
          }) : value.price;
        }

        return _react.default.createElement("span", null, displayPrice);
      }

      return _react.default.createElement("span", null, value);
    }
  }]);
  return PriceCellRenderer;
}(_react.Component);

exports.default = PriceCellRenderer;